import React from 'react';
import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { DialogHeader } from './DialogHeader';
import styles from './template-dialog-helpers.module.css';

const SUBTITLE = 'Enter a name and description for your automation template.';

interface TemplateFormProps {
  templateName: string;
  description: string;
  onTemplateNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  onClose: () => void;
  isLoading: boolean;
  title: string;
  submitLabel: string;
  submittingLabel: string;
  cancelLabel: string;
}

export const TemplateForm: React.FC<TemplateFormProps> = ({
  templateName,
  description,
  onTemplateNameChange,
  onDescriptionChange,
  onSubmit,
  onCancel,
  onClose,
  isLoading,
  title,
  submitLabel,
  submittingLabel,
  cancelLabel,
}) => {
  const isSubmitDisabled = isLoading || !templateName.trim() || !description.trim();

  return (
    <>
      <DialogHeader title={title} subtitle={SUBTITLE} onClose={onClose} showCloseButton />
      <form onSubmit={onSubmit} className={styles.form}>
        <fieldset>
          <div>
            <label htmlFor="template-name">Template Name</label>
            <Input
              type="text"
              id="template-name"
              value={templateName}
              onChange={e => onTemplateNameChange(e.target.value)}
              placeholder="e.g., Welcome Campaign"
              disabled={isLoading}
              autoFocus
            />
          </div>
          <div>
            <label htmlFor="template-description">Description</label>
            <textarea
              id="template-description"
              value={description}
              onChange={e => onDescriptionChange(e.target.value)}
              placeholder="Describe what this automation does..."
              disabled={isLoading}
              rows={3}
            />
          </div>
        </fieldset>

        <footer>
          <Button type="button" onClick={onCancel} disabled={isLoading} variant="outline">
            {cancelLabel}
          </Button>
          <Button type="submit" disabled={isSubmitDisabled} className="bg-primary">
            {isLoading ? submittingLabel : submitLabel}
          </Button>
        </footer>
      </form>
    </>
  );
};
